define(['app/models/messages'], function (Messages) {
    function HelperMessages() {
        const messenger = new Messages();
        const translate = partyking.common.helpers.l.translate;

        const enableCookiesWarning = () => {
            messenger.popupWarning(
                'inline',
                translate(
                    'Aktivera cookies i din webbläsare så att du kan handla roliga prylar hos oss!'
                )
            );
        };

        return {
            enableCookiesWarning,
        };
    }

    return HelperMessages;
});
